import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { colord } from 'colord';
export const getMobileTheme = ()=>({
        '--font-size-h1': '36px',
        '--font-size-h2': '28px',
        '--font-size-h3': '24px',
        '--font-size-h4': '20px',
        '--font-size-h5': '18px',
        '--font-size-h6': '14px',
        '--font-size-p1': '12px',
        '--font-size-p2': '10px',
        '--font-size-p3': '10px',
        '--line-height-h1': '52px',
        '--line-height-h2': '36px',
        '--line-height-h3': '34px',
        '--line-height-h4': '32px',
        '--line-height-h5': '30px',
        '--line-height-h6': '22px',
        '--line-height-p1': '16px',
        '--line-height-p2': '14px',
        '--line-height-p3': '14px'
    });
export function getFullTheme(theme) {
    const fullTheme = _object_spread({}, theme);
    const textStandard = theme['--text-standard'];
    if (textStandard) {
        fullTheme['--text-standard-light'] = colord(textStandard).lighten(0.1).toHex();
    }
    const buttonPrimary = theme['--button-primary'];
    if (buttonPrimary) {
        fullTheme['--button-primary-dark'] = colord(buttonPrimary).darken(0.1).toHex();
        fullTheme['--button-primary-light'] = colord(buttonPrimary).lighten(0.1).toHex();
    }
    const buttonDisabled = theme['--button-disabled'];
    if (buttonDisabled) {
        fullTheme['--button-disabled-dark'] = colord(buttonDisabled).darken(0.1).toHex();
    }
    return fullTheme;
}
